import React, { Component } from "react";
import axios from "axios";
import { Row, Col, Checkbox, Panel, SplitButton, MenuItem, Modal, Button } from "react-bootstrap";
import { FormControlLabel, SelectLabel } from "../components/FormControls";
import LoaderPanel from "../components/LoaderPanel";
import LoaderButton from "../components/LoaderButton";
import LoaderIcon from "../components/LoaderIcon";
import withLoadSave from "../components/LoadSave";
import getvalue from "../utils/getvalue";
import _ from "underscore";
import SaveNavbar from "../components/SaveNavbar";
import { EDFormSection, EDFormBox, EDFormGroup } from "../components/EDDOM";
import SegmentEditor from "../components/SegmentEditor";
import shortid from "shortid";
import delay from "timeout-as-promise";
import notify from "../utils/notify";
import update from "immutability-helper";
import ReactTable from "react-table";
import fixTag from "../utils/fixtag";
import Select2 from "react-select2-wrapper";
import checkSegment from "../utils/check-segment";
import moment from "moment";

import "react-select2-wrapper/css/select2.css";

function ifEmpty(v, e) {
  if (!v || !v.length)
    return e;
  return v;
}

function ValueCell({prop, value, ...props}) {
  if (prop === '!!tags') {
    if (value) {
      var tags = value.split(',');
      return (
        <span>
          <span className="tag-value">{tags[0]}</span>
          {
            tags.length > 1 &&
              ('+ ' + (tags.length-1).toLocaleString() + ' more')
          }
        </span>
      );
    } else {
      return <span/>
    }
  } else if (value === 'true') {
    return <i className="fa fa-check-square-o" />;
  } else {
    return <span>{value}</span>;
  }
}

class ContactsFind extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSearching: false,
      isTagging: false,
      searchedData: null,
      result: null,
      tags: [],
      selected: {},
      selectAll: false,
      showConfirm: false,
      newSegmentName: '',
      newSegmentType: 'one',
      saving: false,
    }

    this.props.setLoadedCB(this.handleSubmit);
  }

  handleChange = event => {
    this.setState({[event.target.id]: getvalue(event)})
  }

  onHeaderCheckChange = e => {
    var val = getvalue(e);
    var p = {selectAll: val};
    if (!val)
      p.selected = {};
    this.setState(p);
  }

  onCheckChange = e => {
    var val = getvalue(e);
    var p = {};
    p.selected = update(this.state.selected, {[e.target.id]: {$set: val}});
    this.setState(p);
  }

  isSelected = s => {
    return this.state.selectAll || this.state.selected[s.Email] || false;
  }

  selectedCount = () => {
    var cnt = 0;
    for (var i in this.state.selected) {
      if (this.state.selected[i])
        cnt++;
    }
    return cnt;
  }

  doSearch = async (data, sort) => {
    var p = { sort: sort };
    _.extend(p, data);

    var ret = (await axios.post('/api/lists/' + this.props.id + '/find', p)).data;
    if (ret.result) {
      this.setState({result: ret.result});
      return;
    } else {
      var id = ret.id;

      var times = 0;

      while (true) {
        times++;

        await delay(2000);

        var results = (await axios.get('/api/listfind/' + id)).data;

        if (results.error) {
          notify.show(results.error, "error");
          return;
        } else if (results.complete) {
          this.setState({result: results.result});
          return;
        } else if (times >= 40) {
          notify.show("Search timed out, please try again", "error");
          return;
        }
      }
    }
  }

  handleSubmit = async event => {
    if (event) {
      event.preventDefault();
    }
    if (!this.props.data.parts.length) {
      notify.show("Please add one or more rules", "error");
      return;
    }
    if (!checkSegment(this.props.data)) {
      notify.show("Cannot search, one or more fields are missing required values", "error");
      return;
    }

    this.setState({isSearching: true, searchedData: this.props.data});

    try {
      await this.doSearch(this.props.data, {id: 'Email', desc: false});
    } finally {
      this.setState({isSearching: false});
    }

    this.setState({mode: 'results'});
  }

  goBack = () => {
    this.props.history.push('/contacts');
  }

  onTagChange = event => {
    this.setState({tags: _.filter(_.map(getvalue(event), fixTag), t => t)});
  }

  addTagsAll = async () => {
    if (!this.state.tags.length) {
      notify.show("Please enter one or more tags first", "error");
      return;
    }

    this.setState({isTagging: true});
    try {
      await axios.post('/api/lists/' + this.props.id + '/tag', {
        segment: this.state.searchedData,
        tags: this.state.tags,
      });
      notify.show("Tag request submitted", "success");
    } finally {
      this.setState({isTagging: false});
    }
  }

  removeTagsAll = async () => {
    if (!this.state.tags.length) {
      notify.show("Please enter one or more tags first", "error");
      return;
    }
    this.setState({isTagging: true});
    try {
      await axios.post('/api/lists/' + this.props.id + '/tag', {
        segment: this.state.searchedData,
        removetags: this.state.tags,
      });
      notify.show("Untag request submitted", "success");
    } finally {
      this.setState({isTagging: false});
    }
  }

  addTagsSel = async () => {
    if (!this.state.tags.length) {
      notify.show("Please enter one or more tags first", "error");
      return;
    }

    this.setState({isTagging: true});
    try {
      await axios.post('/api/lists/' + this.props.id + '/tag', {
        emails: _.filter(_.keys(this.state.selected), e => this.state.selected[e]),
        tags: this.state.tags,
      });
      notify.show("Tag request submitted", "success");
    } finally {
      this.setState({isTagging: false});
    }
  }

  removeTagsSel = async () => {
    if (!this.state.tags.length) {
      notify.show("Please enter one or more tags first", "error");
      return;
    }
    this.setState({isTagging: true});
    try {
      await axios.post('/api/lists/' + this.props.id + '/tag', {
        emails: _.filter(_.keys(this.state.selected), e => this.state.selected[e]),
        removetags: this.state.tags,
      });
      notify.show("Untag request submitted", "success");
    } finally {
      this.setState({isTagging: false});
    }
  }

  saveClicked = () => {
    if (!this.props.data.parts.length) {
      notify.show("Please add one or more rules", "error");
      return;
    }
    if (!checkSegment(this.props.data)) {
      notify.show("Cannot save, one or more fields are missing required values", "error");
      return;
    }

    this.setState({showConfirm: true});
  }

  modalChange = event => {
    this.setState({[event.target.id]: event.target.value});
  }

  saveConfirmClicked = async ok => {
    if (!ok) {
      this.setState({showConfirm: false});
      return false;
    }

    this.setState({saving: true});

    var p = {
      name: this.state.newSegmentName,
      subset: false,
      subsettype: 'percent',
      subsetpct: 10,
      subsetnum: 2000,
    };

    var listpart = {
      type: 'Lists',
      operator: 'in',
      list: this.props.id,
      segment: this.props.segments.length ? this.props.segments[0].id : '',
    };

    if (this.state.newSegmentType === 'all') {
      p.operator = this.props.data.operator;
      p.parts = this.props.data.parts;
    } else if (this.props.data.parts.length === 1 && this.props.data.operator !== 'nor') {
      p.operator = 'and';
      p.parts = [
        listpart,
        this.props.data.parts[0],
      ];
    } else {
      p.operator = 'and';
      p.parts = [{
        type: 'Group',
        operator: this.props.data.operator,
        parts: this.props.data.parts,
      },
      listpart,
      ];
    }

    await axios.post('/api/segments', p);

    this.props.history.push('/segments');
  }

  render() {
    var result = this.state.result;

    let columns = [{
      Header: <Checkbox className="nomargin" checked={this.state.selectAll}
                        onChange={this.onHeaderCheckChange} disabled={this.state.isTagging} />,
      accessor: '',
      Cell: ({...props}) => {
        return <Checkbox className="nomargin" id={props.original.Email} checked={this.isSelected(props.original)}
                         onChange={this.onCheckChange} disabled={this.state.isTagging || this.state.selectAll} />;
      },
      width: 35,
    }];

    if (result && result.allprops) {
      _.map(result.allprops, (p, i) => {
        columns.push({
          Header: p === '!!tags' ? 'Tags' : p,
          headerClassName: i === 0?'text-left':'text-center',
          className: i === 0?'text-left':'text-center',
          Cell: ({...props}) => <ValueCell prop={p} value={props.value} />,
          accessor: p,
        });
      });
    }

    let selcount = this.selectedCount();

    let sa = this.state.selectAll;

    let listName = this.props.list && (this.props.list.name || '')

    return (
      <SaveNavbar title={`Search for Contacts ${listName ? 'in ' + listName : ''}`}
                  hideSave={true} onBack={this.goBack} user={this.props.user}>
        <LoaderPanel isLoading={this.props.isLoading}>
          <EDFormSection onSubmit={this.handleSubmit}>
            <EDFormBox>
              <SegmentEditor data={this.props.data} update={this.props.update}
                lists={this.props.lists} segments={this.props.segments} campaigns={this.props.campaigns}
                tags={this.props.tags} countries={this.props.countries} fields={this.props.allfields}
                verb="Find contacts where"
                addRuleButtonClass="green"
                hideList={true}
              />
              <EDFormGroup className="text-center">
                <SplitButton id="search" className="blue" title="Search" bsStyle="primary" bsSize="large" type="submit" disabled={this.state.isSearching || this.state.isTagging}>
                  <MenuItem disabled={this.state.isSearching || this.state.isTagging} onClick={this.saveClicked}>Save Search as Segment</MenuItem>
                </SplitButton>
                <Modal show={this.state.showConfirm}>
                  <Modal.Header>
                    <Modal.Title>Save as Segment</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <FormControlLabel
                      id="newSegmentName"
                      label="Name"
                      obj={this.state}
                      onChange={this.modalChange}
                    />
                    <SelectLabel
                      id="newSegmentType"
                      label="Include Contacts From"
                      obj={this.state}
                      onChange={this.modalChange}
                      space
                    >
                      <option value="one">This List Only</option>
                      <option value="all">All Lists</option>
                    </SelectLabel>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={this.saveConfirmClicked.bind(this, true)} bsStyle="primary"
                      disabled={!this.state.newSegmentName || this.state.saving}>
                      Create
                    </Button>
                    <Button onClick={this.saveConfirmClicked.bind(this, false)}>Cancel</Button>
                  </Modal.Footer>
                </Modal>
              </EDFormGroup>
              {
                this.state.isSearching &&
                <div className="text-center space-top">
                  <h3>Highly trained badgers are combing through our vast data repository...please be patient...</h3>
                  <LoaderIcon />
                </div>
              }
              {
              (!this.state.isSearching && result) &&
              (!result.rows.length ?
              <h4 className="text-center space-top">
                No data found for query
              </h4>
              :
              <div className="space-top">
                <h4>
                  Displaying {result.rows.length} of {result.count.toLocaleString()} contacts
                </h4>
                <ReactTable
                  data={result.rows}
                  columns={columns}
                  minRows={0}
                  multiSort={false}
                  showPagination={false}
                  defaultPageSize={50}
                  sortable={false}
                />
                <Panel>
                  <Panel.Body>
                    <Row>
                      <Col md={6}>
                        <Select2
                          multiple
                          value={this.state.tags}
                          data={this.props.tags}
                          onChange={this.onTagChange}
                          style={{width:'100%'}}
                          options={{
                            tags: true,
                            placeholder: "Enter tags here",
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <div className="visible-xs visible-sm">&nbsp;</div>
                        <LoaderButton onClick={sa?this.addTagsAll:this.addTagsSel} disabled={(!sa && !selcount)}
                          text={
                            sa?
                              <span>
                                Add Tag{this.state.tags.length===1?'':'s'} To All {result.count.toLocaleString()} Contacts
                              </span>
                            :
                              <span>
                                Add Tag{this.state.tags.length===1?'':'s'} To {selcount===0?'Selected':selcount} Contacts
                              </span>
                          }
                          loadingText="Tagging..."
                          id="tag-split"
                          splitItems={[
                            { text: sa ?
                                    <span>
                                      Remove Tag{this.state.tags.length===1?'':'s'} From All {result.count.toLocaleString()} Contacts
                                    </span>
                                    :
                                    <span>
                                      Remove Tag{this.state.tags.length===1?'':'s'} From {selcount===0?'Selected':selcount} Contact{selcount===1?'':'s'}
                                    </span>,
                              onClick: sa?this.removeTagsAll:this.removeTagsSel,
                              key: 'untag',
                              disabled: (!sa && !selcount),
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                  </Panel.Body>
                </Panel>
              </div>)
              }
            </EDFormBox>
          </EDFormSection>
        </LoaderPanel>
      </SaveNavbar>
    );
  }
}

export default withLoadSave({
  initial: {
    parts: [{
      id: shortid.generate(),
      type: 'Info',
      tag: '',
      prop: '',
      operator: 'contains',
      value: '',
      addedtype: 'inpast',
      addednum: 30,
      addedstart: moment().subtract(30, 'days').format(),
      addedend: moment().format(),
    }],
    operator: 'and',
    subset: false,
    subsettype: 'percent',
    subsetpct: 10,
    subsetnum: 2000,
  },
  extend: ContactsFind,
  extra: {
    list: async ({id}) => (await axios.get('/api/lists/' + id)).data,
    lists: async () => ifEmpty(_.map(_.sortBy((await axios.get('/api/lists')).data, l => l.name.toLowerCase()), l => ({id: l.id, text: l.name})), [{id: '', text: 'None Available'}]),
    segments: async ({id}) => ifEmpty(_.map(_.sortBy(_.filter((await axios.get('/api/segments')).data, s => s.id !== id), s => s.name.toLowerCase()), s => ({id: s.id, text: s.name})), [{id: '', name: 'None Available'}]),
    campaigns: async () => _.map((await axios.get('/api/recentbroadcasts')).data, c => ({id: c.id, text: c.name, linkurls: c.linkurls, is_bc: c.is_bc, updated_at: c.updated_at, modified: c.modified})),
    tags: async() => (await axios.get('/api/recenttags')).data,
    countries: async() => (await axios.get('/api/countries')).data,
    allfields: async () => (await axios.get('/api/allfields')).data,
  },
});



// WEBPACK FOOTER //
// ./src/containers/ContactsFind.js